import { cva } from "class-variance-authority";

export const stylesDemoTrading = cva(
  "px-[12px] py-[2px] rounded-[20px] text-[14px] font-medium leading-[20px] text-light-second ml-[24px] whitespace-nowrap",
  {
    variants: {
      mode: {
        light: "bg-gradient-to-r from-white via-[#FF8800] via-[47.596%] to-[#FF6F00]",
        dark: "bg-gradient-to-r from-white via-[#FF8800] via-[47.596%] to-[#FF6F00]"
      }
    }
  }
);

export const stylesLiveTrading = cva(
  "flex justify-center items-center px-[12px] py-[5px] rounded-[20px] text-[14px] leading-[20px] mr-[24px] cursor-pointer",
  {
    variants: {
      mode: {
        light: "text-light-primary bg-light-primary-14",
        dark: "text-dark-primary bg-dark-primary-14"
      }
    }
  }
);
